import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CatalogItemListRequest } from '@common/model/catalog/item/list.request';
import { coreCatalogApi } from '@cp/entities/catalog';
import { Map, MapHandle, MapMarkerConfig, MapProps } from 'src/shared/ui/map';
import { catalogLayoutMapInstanceSelector, catalogLayoutSlice } from 'src/features/catalog';
import { MAP_MARKER_CLICK_HANDLER_NAME, useMapMarkerClickHandler } from './hooks/useMapMarkerClickHandler';

export interface CatalogMapProps extends MapProps {
  listRequest: CatalogItemListRequest;
}

export const CatalogMap = React.forwardRef<MapHandle, CatalogMapProps>(({ listRequest, ...mapProps }, ref) => {
  const dispatch = useDispatch();
  const mapInstance = useSelector(catalogLayoutMapInstanceSelector);
  const { data: catalogLocations } = coreCatalogApi.endpoints.getMapCatalogItems.useQuery({ ...listRequest, pagination: 10000 });
  useMapMarkerClickHandler();

  const markers = React.useMemo<MapMarkerConfig<number>[] | undefined>(() => {
    if (!mapInstance || !catalogLocations) {
      return;
    }

    return catalogLocations.map((catalogItem) => {
      const { id, location, clientProfile } = catalogItem;
      return {
        id,
        location: location || (clientProfile.location as string),
        iconUrl: '/img/map-mark-icon__default.svg',
        onClick: (event) => {
          window[MAP_MARKER_CLICK_HANDLER_NAME](catalogItem.id, event);
        },
      };
    });
  }, [catalogLocations, mapInstance]);

  return (
    <Map
      ref={ref}
      {...mapProps}
      markers={markers}
      onMapCreated={(mi) => dispatch(catalogLayoutSlice.actions.setMapInstance(mi))}
      onMapDestroy={() => dispatch(catalogLayoutSlice.actions.setMapInstance(undefined))}
    />
  );
});
